import React from "react";
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

import AuthorizeService from "./api-authorization/AuthorizeService";

import Api from "../utils/Api";
import DateHelper from "../utils/DateHelper";

export default class Subscription extends React.Component
{
	constructor(props)
	{
		super(props);
		this.state = {loading: true, authenticated: false, isPremiumUser: false};
	}

	async handleSubscriptionRemove(customerId, subscriptionId /*, event*/)
	{
		// TODO: put up some sort of loading/waiting screen
		const subscriptionInformation = await Api.cancelSubscription(customerId, subscriptionId);

		this.setState({subscriptionInformation});
	}

	async handleSubscriptionReactivate(customerId, subscriptionId /*, event*/)
	{
		// TODO: put up some sort of loading/waiting screen
		const subscriptionInformation = await Api.reactivateSubscription(customerId, subscriptionId);

		this.setState({subscriptionInformation});
	}

	componentDidMount()
	{
		this.makeRemoteRequest();
	}

	async makeRemoteRequest()
	{
		const authenticated = await AuthorizeService.isAuthenticated();
		const isPremiumUser = await AuthorizeService.isPremiumUser();
		// TODO: make these go in parallel
		const subscriptionInformation = await Api.getSubscriptionInformation();
		this.setState({loading: false, authenticated, isPremiumUser, subscriptionInformation});
	}

	render()
	{
		const {loading, authenticated, isPremiumUser, subscriptionInformation} = this.state;

		if (loading)
		{
			return <div></div>;
		}

		if (!authenticated)
		{
			return <div>Currently not authenticated</div>;
		}

		if (!isPremiumUser)
		{
			return <div>Upgrade to see this page</div>;
		}

		const startDateString = DateHelper.formatDate(subscriptionInformation.subscriptionStartDate);
		const endDateString = DateHelper.formatDate(subscriptionInformation.currentPeriodEndDate);
		const endDate = new Date(subscriptionInformation.currentPeriodEndDate+"+00:00");
		const expired = new Date() > endDate;
		let status = "Active";
		if (expired)
		{
			status = "Expired";
		}
		else if (subscriptionInformation.cancelled)
		{
			status = "Will not renew";
		}
		return (
			<Row>
				<Col xs={8} xsOffset={2}>
					<Row>
						<Col xs={4}>
							<label>Subscription Start</label>
						</Col>
						<Col xs={8}>{startDateString}</Col>
					</Row>
					<Row>
						<Col xs={4}>
							<label>Current Period End</label>
						</Col>
						<Col xs={8}>{endDateString}</Col>
					</Row>
					<Row>
						<Col xs={4}>
							<label>Status</label>
						</Col>
						<Col xs={8}>{status}</Col>
					</Row>
					{expired ?
						<Row>
							<Col xs={12}>
								Subscription expired, click <Link to="/upgrade">here</Link> to renew
							</Col>
						</Row>
						:
						<Row>
							<Col xs={8} xsOffset={4}>
							{subscriptionInformation.cancelled ?
								<button
									className="btn-sm btn-success"
									onClick={this.handleSubscriptionReactivate.bind(this, subscriptionInformation.customerId, subscriptionInformation.subscriptionId)}
								>
									Renew
								</button>
								:
								<button
									className="btn-sm btn-danger"
									onClick={this.handleSubscriptionRemove.bind(this, subscriptionInformation.customerId, subscriptionInformation.subscriptionId)}
								>
									Cancel
								</button>
							}
							</Col>
						</Row>
					}
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/Subscription.jsx